<template>
  <div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <span class="font-weight-bold font-size-3 text-dark-60">
        {{
        $t("AUTH.GENERAL.NO_ACCOUNT")
        }}
      </span>&nbsp;&nbsp;
      <router-link
        class="font-weight-bold font-size-3 ml-2"
        :to="{ name: 'register' }"
      >{{ $t("AUTH.GENERAL.SIGNUP_BUTTON") }}</router-link>
    </div>

    <div class="login-form login-signin">
      <div class="text-center mb-5">
        <h3 class="font-size-h1">Восстановление пароля</h3>
      </div>

      <v-alert type="success" :value="sentRepeatCode">
        <div class="alert-text">На ваш номер телефона отправлен код подтверждения</div>
      </v-alert>
      <v-alert type="error" :value="errors.length > 0">
        <div v-for="(error, i) in errors" :key="i">{{ error }}</div>
      </v-alert>

      <v-form ref="form" v-model="valid" :lazy-validation="false">
        <v-text-field
          v-model="form.phone"
          type="text"
          :rules="phoneRules"
          label="Номер телефона"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.password"
          type="password"
          :rules="passwordRules"
          label="Пароль"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.code"
          type="text"
          :rules="codeRules"
          label="Код подтверждения"
          required
          v-if="this.form.phone"
        ></v-text-field>
        <div class="d-flex justify-end">
          <a href="#" @click.prevent="repeatCode" v-if="this.form.phone">Выслать код подтверждения</a>
        </div>
        <div class="d-flex align-center justify-space-between mt-5">
          <router-link :to="{name: 'login'}">Назад</router-link>
          <v-btn color="primary" @click="onSubmit" :loading="submitting">Подтвердить</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { REPEAT_CODE_BY_PHONE } from "@/core/services/store/auth.module";
import { RESET_PASSWORD } from "@/core/services/store/auth.module";
import { RESET_ERRORS } from "@/core/services/store/auth.module";

export default {
  name: "restore",
  metaInfo: {
    title: "Восстановление пароля",
  },
  data() {
    return {
      valid: true,
      errors: [],
      form: {
        phone: "",
        password: "",
        password_confirmation: "",
        code: "",
      },
      submitting: false,
      sentRepeatCode: false,
      phoneRules: [(v) => !!v || "не может быть пустым"],
      passwordRules: [(v) => !!v || "не может быть пустым"],
      codeRules: [(v) => !!v || "не может быть пустым"],
    };
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.$store.dispatch(RESET_ERRORS);
        this.sentRepeatCode = false;

        this.$store
          .dispatch(RESET_PASSWORD, {
            phone: this.form.phone,
            password: this.form.password,
            code: this.form.code,
            role: process.env.VUE_APP_ROLE,
          })
          .then(() => {
            this.$toast.success("Операция выполнена.");
            setTimeout(() => {
              this.$router.push({ name: "login" });
            }, 1000);
          })
          .catch((response) => {
            this.errors = response.data.errors.base;
          })
          .finally(() => (this.submitting = false));
      }
    },
    repeatCode() {
      this.$store.dispatch(RESET_ERRORS);

      this.sentRepeatCode = false;
      this.$store
        .dispatch(REPEAT_CODE_BY_PHONE, {
          phone: this.form.phone,
          role: process.env.VUE_APP_ROLE,
        })
        .then(() => {
          this.sentRepeatCode = true;
        })
        .catch((response) => {
          this.errors = response.data.errors.base;
        })
        .finally(() => (this.submitting = false));
    },
  },
};
</script>
